import $ from 'jquery'

let scrollCounter = 0;
let scrollDelay = 50;
let currentPageID = ''
let navigationHeight = 0
let currentTheme = ''
let userInteraction = false
let currentEvent = false
let currentBrother = false
let navigationScrolled = false
let navigationShowTop = true
let device = false

export function navigationInit() {
    navigationListeners()

    //$(window).on('load', function () {
    window.addEventListener('DOMContentLoaded', function () {
        // alert('ready!');
        navigationUIListeners()
    })
    $(document).ready(function () {
        setTimeout(function () {

            if ($('body').hasClass('device-desktop')) {
                if ($('body').hasClass('single-magazine')) {
                    navigationToggle('open')
                }
            } else {
                //				navigationToggle()
                //console.log('other device2')
            }
        }, 0)
    })
}


// fix for differend submenu heights
export function navigationSetup() {

    // calculateNavigation()
    let classes = $('.c-ppc-adelheid__sub-page.active').attr('class')
    if (classes) {
        let classList = classes.split(' ')
        currentTheme = classList.find(a => a.includes('theme'))
        $('.c-ppc-adelheid__header-hud').addClass(currentTheme)
    }

    calculateNavigation()
}

export function calculateNavigation() {

    // remove previous height calculation
    // $(".c-ppc-adelheid__sub-page").css('height', '');
    // $(".c-ppc-adelheid__page-header-container").css('height', '');

    // recalculate height
    $('.sub-menu').each(function () {
        // if (navigationHeight < $(this).height()) {
        //navigationHeight = $(this).height();
        // }

        //$(this).css('height', navigationHeight);
    })
    // $(".sub-menu").css('height', navigationHeight);
    // $(".c-ppc-adelheid__page-header-container").css('height', navigationHeight);

}

function navigationAncestor() {

    $('.c-ppc-adelheid__sub-page').removeClass('active')
    $('body').removeClass('submenu-open')

    if ($('.c-ppc-adelheid__header-menu .menu-item.children').hasClass('current-ancestor')) {

        $('.c-ppc-adelheid__header-menu .menu-item.children.current-ancestor .c-ppc-adelheid__sub-page').addClass('active')

        $('body').addClass('submenu-open')
    }

    if ($('.c-ppc-adelheid__header-menu .menu-item.children').hasClass('current-page')) {

        $('.c-ppc-adelheid__header-menu .menu-item.children.current-page .c-ppc-adelheid__sub-page').addClass('active')

        $('body').addClass('submenu-open')
    }
}

let subs = document.querySelector('.sub-menu')

function navigationListeners() {

    $(window).on('pub:scrolling:up', function () {
        // if (!userInteraction && document.device !== 'mobile') {
        //     if (!userInteraction) {
        //         //console.log('show top')
        //         navigationToggle('close')
        //     }
        // }
    })

    $(window).on('pub:scrolling:down', function () {
        // //console.log('show close down')
        // if (!userInteraction) {
        // navigationToggle('close')
        // }
    })

    $(window).on('pub:scrolling', function () {
        // //console.log('scrolllllling')
        if (!userInteraction && document.device !== 'mobile') {
            if (!userInteraction) {
                // //console.log('scrollinged')
                navigationToggle('close')
            }
        } else if (userInteraction) {
            if (scrollCounter < scrollDelay) {
                scrollCounter++;
                // //console.log(scrollCounter);
            } else {
                navigationToggle('close')
            }

        }
    })

    $(window).on('pub:scrolled', function () {
        if (!userInteraction && document.device !== 'mobile') {
            navigationToggle('close')
        }
    })

    $(window).on('pub:unscrolled', function () {
        userInteraction = false
        if (!userInteraction && document.device !== 'mobile') {
            navigationToggle('reset')
        }
    })

    $(window).on('pub:viewport', function () {

        device = document.device

        //console.log('pub:viewport' + device)

    })
}

function navigationUIListeners() {

    $('.c-ppc-adelheid__header-navigation').hover(
        function () {
            //			navigationToggle('open')
        }, function () {
            //			navigationToggle('close')
        }
    )

    $('.adelheid-logo').on('click', function (event) {

        const url = window.location.origin

        window.location = url

        return
    })

    $('.lvl-0.c-ppc-adelheid__header-navigation__item > .nav-title').on('click', function (event) {

        userInteraction = true

        if ((!$('body').hasClass('menu-open')) || $(this).parent().hasClass('active')) {
            event.preventDefault()

            $('body').addClass('menu-open')
            navigationOverlayToggle('add')
            return
        }

        if ($(this).parent().children('ul.sub-menu').length) {
            let dropdown = $(this).parent()

            event.preventDefault()

            if ($(dropdown).hasClass('maximize')) {
                if ($(dropdown).hasClass('passive')) {
                    ////console.log('do nothing!')
                    return
                }

                $('.lvl-0.c-ppc-adelheid__header-navigation__item').removeClass('minimize')
                $('.lvl-0.c-ppc-adelheid__header-navigation__item').removeClass('maximize')
                $('.lvl-0.c-ppc-adelheid__header-navigation__item.passive').addClass('maximize')

                navigationOverlayToggle('add')

                return
            }

            $('.lvl-0.c-ppc-adelheid__header-navigation__item').removeClass('maximize')
            $('.lvl-0.c-ppc-adelheid__header-navigation__item').addClass('minimize')

            $(dropdown).removeClass('minimize')
            $(dropdown).addClass('maximize')

            // navigationToggle()
        }
        // navigationOverlayToggle()
        return
    })

    $('.c-ppc-adelheid__header-cancel').on('click', function (event) {
        userInteraction = true
        navigationToggle('reset')
        // }
    })

    $('.c-ppc-adelheid__header-overlay').on('click', function (event) {
        if ($(this).hasClass('active')) {
            navigationToggle()
        }
    })
    //
    $('.c-ppc-adelheid__navigation-button-menu').on('click', function (event) {
        userInteraction = true
        navigationToggle()
    })
    // $('.c-ppc-adelheid__navigation-button-menu').mouseenter(function (event) {
    //     // //console.log(userInteraction)
    //     if (userInteraction !== true) {
    //         navigationToggle()
    //     }
    //     userInteraction = true
    // })
    //
    // $('.menu-item > a').on('click', function (event) {
    //     // if (document.device === 'desktop') {
    //     currentEvent = event;
    //     event.preventDefault();
    //     navigationEvent(currentEvent, this);
    //     // }
    // });

}

function navigationEvent(event, obj) {
    currentEvent = event

    if (!currentBrother || $(obj).hasClass('brother')) {
        currentBrother = true
    }

    if (!$('body').hasClass('menu-click')) {

        document.body.className += ' menu-click'
        if (currentBrother) {
            document.body.className += ' brother'
        }
        navigationEvent(currentEvent, obj)

    } else {
        window.location = currentEvent.currentTarget.href
    }
}


function navigationOverlayToggle(state = '') {


    if (state === 'remove') {
        $('.c-ppc-adelheid__header-overlay').removeClass('active')
    } else if (state === 'add') {
        $('.c-ppc-adelheid__header-overlay').addClass('active')
    } else {
        $('.c-ppc-adelheid__header-overlay').toggleClass('active')
    }

}

function navigationToggle(state = '') {

    scrollCounter = 0;
    if (state === 'reset') {

        //		onsole.log(state)
        // $('.lvl-0.c-ppc-adelheid__header-navigation__item').removeClass('minimize');
        // $('.lvl-0.c-ppc-adelheid__header-navigation__item').removeClass('maximize');

        $('.lvl-0.c-ppc-adelheid__header-navigation__item').removeClass('minimize')
        $('.lvl-0.c-ppc-adelheid__header-navigation__item').removeClass('maximize')
        $('.lvl-0.c-ppc-adelheid__header-navigation__item.passive').addClass('maximize')

        userInteraction = false;

        return
    }

    // //console.log('here')

    if (($('body').hasClass('menu-open') && !state) || state === 'close') {
        if (!$('body').hasClass('root')) {
            $('.c-ppc-adelheid__sub-page').removeClass('active')
            $('body').removeClass('menu-open')
            //			$('body').removeClass('submenu-open')
        } else {
            //			if ($('body').hasClass('submenu-open')) {
            //				$('body').removeClass('submenu-open')
            //				if ($('body').hasClass('archive')) {
            //					$('body').removeClass('menu-open')
            //				}
            //
            //				if ($('body').is('.page, .single')) {
            //					$('body').removeClass('menu-open')
            //				}
            //			} else {
            $('body').removeClass('menu-open')
            $('body').removeClass('submenu-open')
            //			}
        }
        navigationOverlayToggle('remove')
        $('.c-ppc-adelheid__header-hud').removeClass('theme-red theme-white theme-coral theme-black')
        $('.c-ppc-adelheid__header-hud').addClass(currentTheme)

        // navigationToggle('reset')

        userInteraction = false;
        //$('.lvl-0.c-ppc-adelheid__header-navigation__item').removeClass('minimize');
        //$('.lvl-0.c-ppc-adelheid__header-navigation__item').removeClass('maximize');

    } else {

        //		//console.log(state)
        $('body').addClass('menu-open')
        navigationOverlayToggle('add')

        if (state === '') {

        }

    }

    navigationAncestor()

}

//
// export default { navigationInit, navigationSetup }
